import React, { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";

export const AuditReports = () => {
	const [openIndices, setOpenIndices] = useState([]); // Use array instead of single index

	const norms = [
		{
			name: "Audit Reports - 2022-23",
			url: "https://gpsakoli.ac.in/public/api/assets/MOUs_PDFs//C.A.%20Report%202023.pdf",
		},
		{
			name: "Audit Reports - 2023-24",
			url: "https://gpsakoli.ac.in/public/api/assets/MOUs_PDFs//AR2324.pdf",
		},
		{
			name: "Audit Reports - 2024-25",
			url: "https://gpsakoli.ac.in/public/api/assets/MOUs_PDFs//AR2425.pdf",
		}
	];

	const togglePDF = (index) => {
		if (openIndices.includes(index)) {
			setOpenIndices(openIndices.filter((i) => i !== index)); // Close if already open
		} else {
			setOpenIndices([...openIndices, index]); // Open if not already open
		}
	};

	return (
		<div className="container mx-auto p-4">
			<h1 className="heading heading-top-left-line"> Audit Reports</h1>
			<ul className="space-y-3">
				{norms.map((norm, index) => (
					<li
						key={index}
						className="p-4 shadow-md"
						style={{
							background: "linear-gradient(160deg, var(--primary-bg-red), var(--card-linear-dark-red))",
						}}
					>
						<button
							onClick={() => togglePDF(index)}
							className="w-full flex justify-between items-center text-lg font-semibold text-white hover:underline focus:outline-none"
						>
							<span>{norm.name}</span>
							{openIndices.includes(index) ? <FiMinus size={20} /> : <FiPlus size={20} />}
						</button>

						{openIndices.includes(index) && (
							<div className="mt-3 border rounded-lg overflow-hidden">
								<iframe
									src={norm.url}
									width="100%"
									height="500px"
									className="border-none"
									title={norm.name}
								></iframe>
							</div>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};
